import { getDashboardSalesData, getDashboardSummary, getDashboardTopCat, getTenantDashboard } from '../apis/dashboardAPIs';
import { createSlice } from '@reduxjs/toolkit';
import { getSystemPortalDashboard } from '../apis/dashboardAPIs';

interface initialStateInterFace {
	error: any;
	loading: boolean;
	data: any;
	summaryList: any;
}

const initialState: initialStateInterFace = {
	loading: false,
	error: [],
	data: {},
	summaryList: [],
};
const ordersSlice = createSlice({
	name: 'productSlice',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(
			getSystemPortalDashboard.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getSystemPortalDashboard.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.data = action?.payload?.data;
				state.error = '';
			}
		);
		builder.addCase(
			getSystemPortalDashboard.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			getTenantDashboard.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getTenantDashboard.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.data = action?.payload?.data;
				state.error = '';
			}
		);
		builder.addCase(
			getTenantDashboard.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			getDashboardSummary.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getDashboardSummary.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.summaryList = action?.payload?.data;
				state.error = '';
			}
		);
		builder.addCase(
			getDashboardSummary.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			getDashboardSalesData.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getDashboardSalesData.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			getDashboardSalesData.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
		builder.addCase(
			getDashboardTopCat.pending,
			(state: initialStateInterFace) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			getDashboardTopCat.fulfilled,
			(state: initialStateInterFace) => {
				state.loading = false;
				state.error = '';
			}
		);
		builder.addCase(
			getDashboardTopCat.rejected,
			(state: initialStateInterFace) => {
				state.loading = false;
			}
		);
	}
});
export default ordersSlice.reducer;
